/* eslint-disable react/no-array-index-key */
import FAQBlock from '@components/organisms/seo/FAQBlock';
import { customLink, linkResolver } from '@lib/data/prismic/helpers';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import React from 'react';

const SliceFAQ = ({
  slice,
}: {
  slice: {
    primary: { title: string };
    items: { question: string; answer: RichTextBlock[] }[];
  };
}) => (
  <FAQBlock
    title={slice.primary.title}
    items={slice.items.map((item) => ({
      question: item.question,
      answer: (
        <RichText
          render={item.answer}
          linkResolver={linkResolver}
          serializeHyperlink={customLink}
        />
      ),
    }))}
  />
);

export default SliceFAQ;
